// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__t9efb","row":"ProcedureTreatmentSummary_row__161k5"};